import { Translate } from '../../../../shared/LanguageService';
import { ValidationMessage } from '../../../../shared/validationErrors';
import { UpdateEditingStyleFailure } from './useUpdateEditingStyle';

type InUseCustomers = {
    customers?: string[];
    remainingCustomerCount?: number;
};

function customerList(state: InUseCustomers): string {
    const names = (state.customers || []).join(', ');
    const remaining = state.remainingCustomerCount || 0;

    if (remaining === 0) {
        return names;
    }

    return `${names} ${Translate('editing-styles/form/error/in-use-remaining-customers', {
        count: remaining
    })}`;
}

function messageText(message: ValidationMessage): string {
    const state = message.state as InUseCustomers;

    if (state.customers === undefined) {
        return Translate(message.key);
    }

    return Translate(message.key, { customers: customerList(state) });
}

export function updateErrorText(updateError: UpdateEditingStyleFailure | null): string {
    if (updateError === null) {
        return '';
    }

    if (updateError.messages.length > 0) {
        return updateError.messages.map(messageText).join(' ');
    }

    return Translate('editing-styles/notification/update-failed', { name: updateError.name });
}
